<p-multiSelect
  [options]="translatedOptions"
  [(ngModel)]="selectedOptions"
  optionLabel="label"
  optionValue="value"
  [placeholder]="'SHARED.COLUMN_OPTIONS' | translate"
  [displaySelectedLabel]="false"
  [showHeader]="false"
  styleClass="column-options {{ styleClass }}"
  panelStyleClass="column-options-panel {{ panelStyleClass }}"
  (onChange)="onSelectItem($event)"
>
  <ng-template let-option pTemplate="item">
    {{ option.label }}
  </ng-template>
</p-multiSelect>
